// removed by extract-text-webpack-plugin
module.exports = {"lectureIndicator":"LectureIndicator-cssmodule-lectureIndicator-2rCy4","indicator":"LectureIndicator-cssmodule-indicator-PZytw"};


//////////////////
// WEBPACK FOOTER
// ./themes/BlueTheme/LectureIndicator.cssmodule.less
// module id = 674
// module chunks = 0